import React, { useState, useEffect } from 'react'
import CustomChip from '../../../../common/customChip/CustomChip';
import { endpoint } from '../../../../common/constant';
import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';

export const useGetAllBusinessArea = (activeOnly = false, getLabel = (bu) => bu?.businessAreaDispValue) => {
    const [allBu, setAllBu] = useState([]);

    useEffect(() => {
        const url = activeOnly ? endpoint?.businessArea?.getAllActiveV2 : endpoint?.businessArea?.getAll;

        const fetchBu = async () => {
            try {
                const resp = await fetchAllPromisedData(url, true);
                if (resp?.code === 200) {
                    setAllBu(resp?.data?.map(bu => ({ ...bu, label: getLabel(bu), value: bu?.id })));
                }
            } catch (err) {
                console.log(err);
            }
        }

        fetchBu();
    }, []);

    return allBu;
}

export const StatusChip = ({ val }) => {
    const status = {
        "ACTIVE": { text: 'Active', bgColor: '#BBE2CE', textColor: '#0B442D' },
        "INACTIVE": { text: 'Inactive', bgColor: '#F5F5F5' },
    }

    return <CustomChip {...status[val]} style={{ fontSize: '12px' }} />
}

export const UserNameByUserId = ({ userId }) => {
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const getUserNameByUserId = async () => {
            try {
                const resp = await fetchAllPromisedData(`${endpoint.getAllUserByUserKeyList}?userKeyList=${userId}`, true);
                if (resp?.code === 200 && resp?.data?.length > 0) {
                    setUserName(resp?.data[0]?.name);
                }
            } catch (err) {
                console.error(err);
            }
        }
        getUserNameByUserId();
    }, [])

    return <div>{userName || 'Loading...'}</div>
}